require('./style.less');

var Marionette = require('marionette');

module.exports = Marionette.ItemView.extend({
    id: 'esSearchInputWr',
    template: require('./template'),
    initialize: function(options) {
        _.extend(this, _.pick(options, 'lCh', 'model'));
    },
    onRender: function() {
        this.model.docOnServerAndNoFetchErr()
            ? this.ui.searchOverlay.append( this.generateSearchMarkup() ) //append to avoid xss
            : this.ui.searchOverlay.text(this.model.searchText);
    },
    serializeData: function () {
        var m = this.model;
        return {
            search: m.searchText, //(the input)
            showEditButton: (m.docOnServerAndNoFetchErr() )
        };
    },
    ui: {
        newSearchBtn:       '#newSearch',
        searchTxtInput:     '#esSearchTerm',
        newSearchOK:        '.ok',
        newSearchCancel:    '.cancel',
        searchOverlay:      '#esSearchOverlay'
    },
    events: {
        'click @ui.searchOverlay': function(e) {
            e.stopPropagation();
            var $target = $(e.target);
            if (!$target.hasClass('esWord'))
                return;
            this.lCh.command('applyLocalSearchFromESWordClick', $target.text());
        },
        'click @ui.newSearchOK': function () {
            this.lCh.command('resetSearch', this.ui.searchTxtInput.val());
        },
        'click @ui.newSearchBtn': function () {
            this.lCh.command('toggleSearchBarState', true);
        },
        'click @ui.newSearchCancel': function () {
            this.lCh.command('toggleSearchBarState', false);
        },
        'keyup @ui.searchTxtInput': 'keyPressedInNewSearchInput'
    },
    keyPressedInNewSearchInput: function(e) {
        var key = e.keyCode ? e.keyCode : e.which;//norm for IE8 //todo: this would be part of the ok, cancel plugin
        e.stopPropagation(); //prevent mousetrap bubble
        (key === 13) && this.lCh.command('resetSearch', this.ui.searchTxtInput.val());
        (key === 27) && this.lCh.command('toggleSearchBarState', false);
    },
    generateSearchMarkup: function() {
        var searchTxt = this.model.searchText;
        var words = searchTxt.split(' '); //TODO: STOP WORDS -- AND OR
        return _.map(words, function(w) {
            return '<span class="esWord" title="Find ' + w + '">' + w + '</span><span> </span>'; //extra span at end ok
        });

    },
    onToggleSearchReset: function(ui, isEnabled) {
        var $input = this.ui.searchTxtInput;
        this.$el.toggleClass('active', isEnabled);
        this.ui.newSearchOK.toggleClass('btn-focus-primary', isEnabled);
        isEnabled
            ? $input.select()
            : $input.val(this.model.searchText);
    },
    onBeforeDestroy: function() {
        this.off();
        this.$('*').remove();
        this.$el.remove();
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/footer/searchBar/view.js
 ** module id = 532
 ** module chunks = 0
 **/